import centrifugeIconSrc from 'assets/img/centrifugeIcon.svg';
import spokeIconSrc from 'assets/img/spokeIcon.svg';
import vaultsIconSrc from 'assets/img/vaultsIcon.svg';
import venusCoreIconSrc from 'assets/img/venusCoreIcon.png';
import venusFluxIconSrc from 'assets/img/venusFluxIcon.png';
import type { LiquidityHubYieldGroupType } from 'types';

export const metadataByType: Record<
  LiquidityHubYieldGroupType,
  { nameTranslationKey: string; iconSrc: string; bgClassName: string }
> = {
  core: {
    // DO NOT REMOVE COMMENT: needed by i18next to extract translation key
    // t('liquidityHub.allocationDetails.yieldGroup.names.core')
    nameTranslationKey: 'liquidityHub.allocationDetails.yieldGroup.names.core',
    iconSrc: venusCoreIconSrc,
    bgClassName: 'bg-blue',
  },
  flux: {
    // DO NOT REMOVE COMMENT: needed by i18next to extract translation key
    // t('liquidityHub.allocationDetails.yieldGroup.names.flux')
    nameTranslationKey: 'liquidityHub.allocationDetails.yieldGroup.names.flux',
    iconSrc: venusFluxIconSrc,
    bgClassName: 'bg-yellow',
  },
  frv: {
    // DO NOT REMOVE COMMENT: needed by i18next to extract translation key
    // t('liquidityHub.allocationDetails.yieldGroup.names.frv')
    nameTranslationKey: 'liquidityHub.allocationDetails.yieldGroup.names.frv',
    iconSrc: vaultsIconSrc,
    bgClassName: 'bg-orange',
  },
  centrifuge: {
    // DO NOT REMOVE COMMENT: needed by i18next to extract translation key
    // t('liquidityHub.allocationDetails.yieldGroup.names.centrifuge')
    nameTranslationKey: 'liquidityHub.allocationDetails.yieldGroup.names.centrifuge',
    iconSrc: centrifugeIconSrc,
    bgClassName: 'bg-red',
  },
  spoke: {
    // DO NOT REMOVE COMMENT: needed by i18next to extract translation key
    // t('liquidityHub.allocationDetails.yieldGroup.names.spoke')
    nameTranslationKey: 'liquidityHub.allocationDetails.yieldGroup.names.spoke',
    iconSrc: spokeIconSrc,
    bgClassName: 'bg-green',
  },
};

export const isKnownYieldGroupKind = (
  kind: LiquidityHubYieldGroupType | null,
): kind is LiquidityHubYieldGroupType | null => kind === null || kind in metadataByType;
